import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./reisen.component').then(m => m.ReisenComponent)
    },
    {
        path: ':id99',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11/:id12',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11/:id12/:id13',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11/:id12/:id13/:id14',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
    {
        path: ':id99/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11/:id12/:id13/:id14/:id15',
        loadComponent: () => import('./reisendetail/reisendetail.component').then(m => m.ReisendetailComponent)
    },
];
